module.exports = __webpack_public_path__ + "static/img/paytypesel_20x20_@3x.ac293f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paytypesel_20x20_@3x.png
// module id = LHQ0
// module chunks = 1